module.exports = __webpack_public_path__ + "static/img/playerEval.e4abf02c.svg";